import React from 'react'
import { Helmet } from 'react-helmet'

const ListingHelmet = ({ city, name, type }) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>{name ? `${name} | NUGL` : 'NUGL'}</title>
        {name && type && city ? (
          <meta
            name="description"
            content={`Check out ${name}, a ${type} located in ${city} on NUGL.`}
          />
        ) : (
          <meta
            name="description"
            content={`Learn more about ${name} on NUGL, a cannabis search and business directory with social media and networking tools.`}
          />
        )}
      </Helmet>
    </React.Fragment>
  )
}

export { ListingHelmet }



// WEBPACK FOOTER //
// ./src/components/listings/Page/ListingHelmet.js